var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{attrs:{"id":"activeUser"}},[_c('LoginFormComponent',{attrs:{"formType":_vm.isExpired==true? 'EXPIRED_CONFIRM_IP_LINK' : 'CONFIRM_NEW_IP',"formTitle":_vm.isExpired==true ? 'Link expired' : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }